module.exports = __webpack_public_path__ + "img/NWTUAnmeldeSystemTransparent300x78.4ec245bf.png";